import React, { Component } from 'react'
import DashboardPage from './DashboardPage'
import './../styles/_index.scss'
import SkuNotBatches from "./sku-not-batches/SkuNotBatches"
import BatchProductionStatusPage from './BatchProductionStatusPage'
import GarmentQuantityStatisticsPage from './GarmentQuantityStatisticsPage'
import QCHTQuantityStatisticsPage from './QCHTQuantityStatisticsPage'
import PackagedQuantityStatisticsPage from './PackagedQuantityStatisticsPage'
import PrintQuantityStatisticsPage from './PrintQuantityStatisticsPage'
import CutQuantityStatisticsPage from './CutQuantityStatisticsPage'
import EngravedQuantityStatisticsPage from './EngravedQuantityStatisticsPage'
import ImprovedQuantityStatisticsPage from './ImprovedQuantityStatisticsPage'
import store from 'store'
import { Icon, Select } from "antd"

class DashboardContainer extends Component {

    state = {
        activeTab: '',
        statisticsType: 'print'
    }

    componentDidMount() {
        const activeTab = store.get('3d_dashboard')

        this.setState({
            activeTab: !!activeTab && ['produce','BatchProductionStatus','QuantityStatistics'].includes(activeTab) ? activeTab : 'produce'
        })
    }

    _onChangeTabActive = (active) => {
        this.setState({
            activeTab: active,
            statisticsType: 'print',
        }, () => {
            store.set('3d_dashboard', this.state.activeTab)
        })
    }

    _getActiveTab = () => {
        const { activeTab, statisticsType } = this.state
        // if (activeTab === 'overtime') { return <DashboardPage /> }
        if (activeTab === 'BatchProductionStatus') { return <BatchProductionStatusPage /> }
        if (activeTab === 'produce') { return <SkuNotBatches /> }
        if (activeTab === 'QuantityStatistics') {
            if (statisticsType === 'Sewed') {
                return <GarmentQuantityStatisticsPage />
            }
            if (statisticsType === 'QCHT') {
                return <QCHTQuantityStatisticsPage />
            }
            if (statisticsType === 'Packaged') {
                return <PackagedQuantityStatisticsPage />
            }
            if (statisticsType === 'print') {
                return <PrintQuantityStatisticsPage />
            }
            if (statisticsType === 'cut') {
                return <CutQuantityStatisticsPage />
            }
            if (statisticsType === 'engraved') {
                return <EngravedQuantityStatisticsPage />
            }
            if (statisticsType === 'improved') {
                return <ImprovedQuantityStatisticsPage />
            }
        }
    }

    _onChangeSelect = (value) => {
        this.setState({
            statisticsType: value
        })
    }

    render() {
        const { activeTab, statisticsType } = this.state

        if (activeTab === '') return null
        const { Option } = Select

        return (
            <div className="DashboardContainer">
                <div className='TabHead p-3 m-3 d-flex justify-content-between'>
                    <ul className='TabFilter'>
                        {/* <li
                            className={`${activeTab === 'overtime' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('overtime')}
                        >
                            <Icon type="bar-chart" className='mr-1' />
                            Thống kê tiến độ sản xuất
                        </li> */}
                        <li
                            className={`${activeTab === 'produce' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('produce')}
                        >
                            <Icon type="area-chart" className='mr-1' />
                            Chưa phân lô
                        </li>
                        <li
                            className={`${activeTab === 'BatchProductionStatus' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('BatchProductionStatus')}
                        >
                            <Icon type="table" className='mr-1' />
                            Trạng thái sản xuất theo lô
                        </li>
                        <li
                            className={`${activeTab === 'QuantityStatistics' ? 'active' : ''}`}
                            onClick={() => this._onChangeTabActive('QuantityStatistics')}
                        >
                            <Icon type="table" className='mr-1' />
                            Thống kê sản lượng
                        </li>
                    </ul>
                    {activeTab === 'QuantityStatistics' &&
                        <div className='selectDiv'>
                            <Select
                                style={{ minWidth: '200px' }}
                                defaultValue={statisticsType}
                                onChange={this._onChangeSelect}
                            >
                                <Option value={'print'}>Sản lượng in</Option>
                                <Option value={'cut'}>Sản lượng cắt</Option>
                                <Option value={'engraved'}>Sản lượng khắc</Option>
                                <Option value={'improved'}>Sản lượng hoàn thiện</Option>
                                {/* <Option value={'Sewed'}>Sản lượng may</Option> */}
                                <Option value={'QCHT'}>Sản lượng QC hoàn thành</Option>
                                <Option value={'Packaged'}>Sản lượng đóng gói</Option>
                            </Select>
                        </div>
                    }
                </div>

                <div className='tabContent'>
                    {
                        this._getActiveTab()
                    }
                </div>
            </div>
        )
    }

}

export default DashboardContainer
